/** One icon per credit role, so a creator's work reads at a glance: pen for writing, palette for art. */
import { BookCheck, DraftingCompass, Languages, LayoutTemplate, Map as MapIcon, Palette, PenLine } from 'lucide-react'
import type { CreditRole } from '../../shared/model'

const ICONS: Record<CreditRole, typeof PenLine> = {
  author: PenLine,
  artist: Palette,
  editor: BookCheck,
  designer: DraftingCompass,
  cartographer: MapIcon,
  translator: Languages,
  layout: LayoutTemplate,
}

export function RoleIcon({ role, size = 14 }: { role: string; size?: number }) {
  const Icon = ICONS[role as CreditRole] ?? PenLine
  return <Icon size={size} aria-hidden="true" />
}
